/* src/app/gest-ristorante/gest-ristorante.component.css */
/*# sourceMappingURL=gest-ristorante.component.css.map */
